
import { Routes, Route } from 'react-router-dom'
import { constants } from './module'
import { PublicPageLayout } from 'frame/components'
import ConfirmationPopups from 'features/fbt-submissions/components/confirmation-popups'

import InitialForm from './initial-form'
import QuestionStep from './question-step'
import Form from './form'
import FormFinish from './form-finish'

const FbtWebFormRoutes = () => (
  <PublicPageLayout>
    <Routes>
      <Route path={constants.ROUTE_ROOT} element={<InitialForm />} />
      <Route path={constants.ROUTE_QUESTION} element={<QuestionStep />} />
      <Route path={constants.ROUTE_FORM} element={<Form />} />
      <Route path={constants.ROUTE_FINISH} element={<FormFinish />} />
    </Routes>

    <ConfirmationPopups fbtWebFormSuccessRedirect={constants.PATH_FORM_FINISH} />
  </PublicPageLayout>
)

export default FbtWebFormRoutes
